import styled from '@emotion/styled';
import { Link, MessageBlock, MessageBlockType, Paragraph, rem } from '@triumph/design-system';
import { useOktaAuth } from '@okta/okta-react';
import { Outlet } from 'react-router-dom';
import { clearSessionTokens } from '@/components/shared/utils/sessionStorageUtils';
import { CopyOrpLinkButton } from '../CopyOrpLinkButton';
import { ErrorBoundary } from '../ErrorBoundary';
import { Header } from '../Header';
import { Container, ContentWrapper, Footer, SignOutButton } from './Layout.StyledComponents';

const StyledParagraph = styled(Paragraph)`
    margin: 0;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: ${rem(6)};
`;

export const Layout = () => {
    const isIframed = window.self !== window.top;
    const { oktaAuth } = useOktaAuth();

    return (
        <Container>
            {!isIframed ? <Header /> : null}
            <ContentWrapper>
                <MessageBlock
                    messageId={1}
                    message={
                        <>
                            <StyledParagraph data-testid="originations-review-portal-slack">
                                Have an Issue or Feedback? Slack us{' '}
                                <Link
                                    href="https://triumph.enterprise.slack.com/archives/C0987QFTQ00"
                                    title="originations-review-portal-feedback"
                                    data-testid="originations-review-portal-slack-link"
                                >
                                    #orp-originations-review-portal-feedback
                                </Link>{' '}
                                and{' '}
                                <CopyOrpLinkButton
                                    label="📄 ORP Link"
                                    data-testid="banner-copy-orp-link-button"
                                    preText={isIframed ? 'Send the URL:' : 'Send the'}
                                />
                            </StyledParagraph>
                        </>
                    }
                    type={MessageBlockType.info}
                    show={true}
                    messageContentContainerTestId="message__inline"
                    width="100%"
                />
                <ErrorBoundary location="layout">
                    <Outlet />
                </ErrorBoundary>
                <Footer>
                    <SignOutButton onClick={() => { clearSessionTokens(); oktaAuth.signOut(); }}>Sign out</SignOutButton>
                </Footer>
            </ContentWrapper>
        </Container>
    );
};
